import { useAuth } from 'oidc-react';
import { ComponentType, useEffect } from 'react';
import { FORBIDDEN_PATH, LOGOUT_BROADCAST_EVENT } from './constants';
import {
  closeBroadcastChannel,
  getBroadcastChannel,
} from './utils/broadcastChannelUtil';

export const withBroadcastChannel = (Component: ComponentType) => {
  const WrappedComponent = (props: any) => {
    const auth = useAuth();

    useEffect(() => {
      const broadcastChannel = getBroadcastChannel();

      const handleBroadcastMessage = async (event: MessageEvent) => {
        if (event.data === LOGOUT_BROADCAST_EVENT) {
          console.log('Received logout message from another tab');

          const oidcState =
            window.location.pathname === FORBIDDEN_PATH
              ? undefined
              : {
                  originalPath: window.location.href,
                };

          await auth.signOutRedirect({
            redirectMethod: 'replace',
            state: oidcState,
          });

          closeBroadcastChannel();
        }
      };

      broadcastChannel.onmessage = handleBroadcastMessage;
    }, [auth]);

    return <Component {...props} />;
  };

  return WrappedComponent;
};
